import { render, staticRenderFns } from "./LoanRequestForm.vue?vue&type=template&id=21aa87c4&scoped=true"
import script from "./LoanRequestForm.vue?vue&type=script&lang=js"
export * from "./LoanRequestForm.vue?vue&type=script&lang=js"
import style0 from "./LoanRequestForm.vue?vue&type=style&index=0&id=21aa87c4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21aa87c4",
  null
  
)

export default component.exports